module.exports = "/_next/static/images/68e4750a5ac4250a2e55f3a396fcff43-complexity@lg-2x.jpg.webp";